import { ticketClient } from "@/api/ticketClient";
import { GetTicketListReq } from "@/pbjs/external/ticket/ticket_pb";
import { ExportTicketEmailCSVReq } from "@/pbjs/xcommon/ticket_pb";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData, timeFormat, whetherSetParam } from "@/utils";
// lee 绩效接口参数
interface Options {
  itemId?: number;
  UrgeResult?: number;
  belongCompany?: number;
  roleList?: Array<number>;
  isRoll?: number;
  isStage?: number;
  outsource?: string;
  ticketId?: string;
  orderId?: string;
  customerId?: string;
  caseId?: string;
  status?: string;
  assignName?: string;
  createTimeRange?: string;
  completeTimeRange?: string;
  closeTimeRange?: string;
  assignTimeRange?: string;
  assignUId?: string;
  isReloan?: number;
  email?: string;
  pageIndex: number;
  pageSize: number;
  prop: number;
  order: number;
  AppName: string;
  mobile: string;
  overdueDays: string;
  TicketTag: string;
  preStatus: string;
  isRobot: string;
  RobotCallIntentTag: string;
}
export function getTicketListExcel(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetTicketListReq();
      request.setCommonin(setCommon());
      request.setItemid(arg.itemId);
      request.setTicketid(arg.ticketId);
      request.setOrderid(arg.orderId);
      request.setCustomerid(arg.customerId);
      request.setCaseid(arg.caseId);
      request.setStatus(arg.status);
      request.setAssignname(arg.assignName);
      request.setAssignuid(arg.assignUId);
      request.setPagein(
        setPage(arg.pageIndex, arg.pageSize, arg.prop, arg.order)
      );
      request.setIsreloan(arg.isReloan);
      request.setUrgeresult(arg.UrgeResult);
      request.setIsentrust(arg.outsource);
      request.setEntrustcompany(arg.belongCompany);
      request.setRoleidsList(arg.roleList);
      request.setIsroll(arg.isRoll);
      request.setIsstage(arg.isStage);
      request.setCreatetimerange(arg.createTimeRange);
      request.setCompletetimerange(arg.completeTimeRange);
      request.setClosetimerange(arg.closeTimeRange);
      request.setAssigntimerange(arg.assignTimeRange);
      console.log(request.toObject(),'数据导出参数')
      // setRank
      let _res = await ticketClient.getTicketListExcel(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            resolve(response);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
export function getExportTicketEmailCSV(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetTicketListReq();
      request.setCommonin(setCommon());
      request.setItemid(arg.itemId);
      request.setTicketid(arg.ticketId);
      request.setOrderid(arg.orderId);
      request.setCustomerid(arg.customerId);
      request.setCaseid(arg.caseId);
      request.setStatus(arg.status);
      request.setAssignname(arg.assignName);
      request.setAssignuid(arg.assignUId);
      request.setPagein(
        setPage(arg.pageIndex, arg.pageSize, arg.prop, arg.order)
      );
      request.setIsreloan(arg.isReloan);
      request.setUrgeresult(arg.UrgeResult);
      request.setIsentrust(arg.outsource);
      request.setEntrustcompany(arg.belongCompany);
      request.setRoleidsList(arg.roleList);
      request.setIsroll(arg.isRoll);
      request.setIsstage(arg.isStage);
      request.setCreatetimerange(arg.createTimeRange);
      request.setCompletetimerange(arg.completeTimeRange);
      request.setClosetimerange(arg.closeTimeRange);
      request.setAssigntimerange(arg.assignTimeRange);
      request.setAppname(arg.AppName);
      request.setMobile(arg.mobile);
      request.setTickettag(arg.TicketTag);
      request.setPrestatusList(arg.preStatus);
      request.setIsrobot(arg.isRobot);
      request.setTickettags(arg.RobotCallIntentTag);
      request.setOverdueday(arg.overdueDays);

      let requestOut: any = new ExportTicketEmailCSVReq();
      requestOut.setCommonin(setCommon());
      requestOut.setGetticketlistreq(request);
      requestOut.setEmail(arg.email || "");
      console.log(requestOut.toObject(),'邮件导出请求参数')
      ticketClient.exportTicketEmailCSV(
        requestOut,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            resolve(response);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      if (response) {
        response.loading = false;
        handleResponse(response, null);
        return response;
      }
      return null;
    })
    .catch((err: any) => {
      errorMsg(err);
      return null;
    });
}
export function getTicketList(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetTicketListReq();
      request.setCommonin(setCommon());
      request.setItemid(arg.itemId);
      request.setTicketid(arg.ticketId);
      request.setOrderid(arg.orderId);
      request.setCustomerid(arg.customerId);
      request.setCaseid(arg.caseId);
      request.setStatus(arg.status);
      request.setAssignname(arg.assignName);
      request.setAssignuid(arg.assignUId);
      request.setPagein(
        setPage(arg.pageIndex, arg.pageSize, arg.prop, arg.order)
      );
      request.setIsreloan(arg.isReloan);
      request.setUrgeresult(arg.UrgeResult);
      request.setIsentrust(arg.outsource);
      request.setEntrustcompany(arg.belongCompany);
      request.setRoleidsList(arg.roleList);
      request.setIsroll(arg.isRoll);
      request.setIsstage(arg.isStage);
      request.setCreatetimerange(arg.createTimeRange);
      request.setCompletetimerange(arg.completeTimeRange);
      request.setClosetimerange(arg.closeTimeRange);
      request.setAssigntimerange(arg.assignTimeRange);
      // setRank
      let _res = await ticketClient.getTicketList(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            resolve(response);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
